import { Map } from 'immutable';
const combineImmutableReducers = reducers => {
  const reducerEntries = Object.entries(reducers);
  return (state, action) => {
    const currentState = state || Map();
    return reducerEntries.reduce((nextState, [key, reducer]) => {
      const previousSlice = nextState.get(key);
      const nextSlice = reducer(previousSlice, action);
      return nextState.set(key, nextSlice);
    }, currentState);
  };
};
export default combineImmutableReducers;